import Layout, { Card, Empty } from '@/components/Layout'
import { router } from '@inertiajs/react'
import { useCanWrite } from '@/lib/access'
import type { TaskFull } from '@/types'

interface Props {
  date_label: string
  viewed_date: string
  max_date: string
  is_today: boolean
  streak: number
  earned_today: number
  total_tasks: number
  done_count: number
  avail: TaskFull[]
  done: TaskFull[]
}

function TaskLine({
  t, done, canWrite, date, isToday,
}: { t: TaskFull; done: boolean; canWrite: boolean; date: string; isToday: boolean }) {
  return (
    <div className={'flex items-center gap-2.5 py-2.5 border-t border-dashed border-[#e7ebf2] first:border-t-0 ' + (done ? 'opacity-65' : '')}>
      <span className="text-[#f5a623] text-[13px] whitespace-nowrap">{done ? '✅' : t.stars}</span>
      <span className="flex-1">
        {t.title} <span className="text-[11px] px-[7px] py-px rounded-md bg-[#eef2ff] text-[#707d90]">{t.goal_title}</span>
      </span>
      <span className="font-bold text-[#5b7cfa] whitespace-nowrap">+{t.points}</span>
      {canWrite && (done ? (
        <button onClick={() => router.delete(`/checkin/${t.id}`, { data: { date } })} className="bg-[#eef2ff] text-[#5b7cfa] font-semibold text-[13px] px-3 py-1.5 rounded-[10px]">撤销</button>
      ) : (
        <button onClick={() => router.post(`/checkin/${t.id}`, { date })} className="bg-[#2ec16b] text-white font-semibold text-[13px] px-3 py-1.5 rounded-[10px]">{isToday ? '打卡' : '补打卡'}</button>
      ))}
    </div>
  )
}

export default function Index({
  date_label, viewed_date, max_date, is_today, streak, earned_today, total_tasks, done_count, avail, done,
}: Props) {
  const canWrite = useCanWrite()
  const earnedLabel = is_today ? '今日已得分' : '当日已得分'
  const doneTasksLabel = is_today ? '今日完成任务' : '当日完成任务'
  const titlePrefix = is_today ? '✅ 今日打卡' : '🗓️ 补打卡'

  return (
    <Layout>
      <Card
        title={<>{titlePrefix} <span className="text-[#707d90] font-normal text-[13px]">· {date_label}</span></>}
        extra={
          <input
            type="date"
            value={viewed_date}
            max={max_date}
            onChange={(e) => router.get('/checkin', { date: e.target.value }, { preserveScroll: true })}
            className="border border-[#e7ebf2] rounded-[10px] px-2.5 py-1.5 text-[13px] text-[#3a4759]"
          />
        }
      >
        <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(150px,1fr))]">
          <div className="bg-white border border-[#e7ebf2] rounded-2xl px-4 py-3.5"><div className="text-[26px] font-extrabold text-[#f5a623]">{streak} {streak > 0 ? '🔥' : ''}</div><div className="text-[#707d90] text-[13px] mt-1">连续打卡（天）</div></div>
          <div className="bg-white border border-[#e7ebf2] rounded-2xl px-4 py-3.5"><div className="text-[26px] font-extrabold text-[#2ec16b]">+{earned_today}</div><div className="text-[#707d90] text-[13px] mt-1">{earnedLabel}</div></div>
          <div className="bg-white border border-[#e7ebf2] rounded-2xl px-4 py-3.5"><div className="text-[26px] font-extrabold text-[#5b7cfa]">{done_count}/{total_tasks}</div><div className="text-[#707d90] text-[13px] mt-1">{doneTasksLabel}</div></div>
        </div>
      </Card>

      <Card title={`📌 待打卡（${avail.length}）`}>
        {avail.length ? avail.map((t) => <TaskLine key={t.id} t={t} done={false} canWrite={canWrite} date={viewed_date} isToday={is_today} />) : <Empty>{is_today ? '🎉 今天的任务都打卡完成啦！' : '这一天的任务都已补齐。'}</Empty>}
      </Card>

      <Card title={`✅ 已打卡（${done.length}）`}>
        {done.length ? done.map((t) => <TaskLine key={t.id} t={t} done={true} canWrite={canWrite} date={viewed_date} isToday={is_today} />) : <Empty>这一天还没有打卡记录。万一打错了，可在这里点「撤销」回退。</Empty>}
      </Card>
    </Layout>
  )
}
